
// axios
import axios from 'axios'

import i18n from '../../i18n'
import {
    getModeratorToken,
    getSchoolToken,
    removeModeratorToken,
    removeSchoolToken,
     removeUserData,
    getTestMobile,
} from "../../utils/auth";


const axiosIns = axios.create({
    // baseURL: 'http://ishuzedu/',
    baseURL: 'https://ish.uzedu.uz/api',
    // baseURL: 'https://ish.itsm.uz/api',
    timeout: 1000,
    // headers: {'X-Custom-Header': 'foobar'}
})

axiosIns.interceptors.request.use(config => {
        // eslint-disable-next-line no-param-reassign
        config.headers['Content-Type'] = 'application/json'

        config.headers.Accept = 'application/json'
        config.headers.Language = (i18n.locale ? i18n.locale : 'uz');
        if (getSchoolToken() || getModeratorToken()) {
            config.headers.Authorization = `Bearer ${(getSchoolToken() ? getSchoolToken() : getModeratorToken())}`
        }
        if(getTestMobile()) {
            config.headers['TestToken'] = JSON.parse(getTestMobile()).token;
        }

        return config
    },
    error => {
        Promise.reject(error)
    })

axiosIns.interceptors.response.use(
    response => {
        if (response.message === 'Unauthenticated') {
            window.location = '/login'
        }

        return response
    },
    error => {
        if (error.response.message === 'Unauthenticated') {
            window.location = '/login'
        } else if (error.response.status === 401) {
            removeSchoolToken()
            removeModeratorToken()
            removeUserData()
        return Promise.reject(error)
    }
    })

// Vue.prototype.$http = axiosIns

export default axiosIns
